import { User } from "./User";

export class Organization {
  id?: number;
  name: string;
  description: string;
  address: string;
  tenantId: string;
  admin: User;
  checked?:boolean;
  privacyMode?:boolean;
  isInvalid?: boolean;

  constructor() {
    this.name = "";
    this.description = "";
    this.address = "";
    this.tenantId = "";
    this.admin = new User();
    this.checked = false;
  }
}
